import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, identityProvider }) =>
    present(
      repository
        .saveIdentityProvider(planzone, identityProvider)
        .then((savedIdentityProvider) => ({
          planzone,
          identityProvider: savedIdentityProvider,
        }))
        .catch(() => Promise.reject({ planzone, identityProvider })),
    );
}

export type { Interactor };

export { createInteractor };
